import {
  get, post, update, get2, upload, download
} from './helpers'

// API GENERAL
export function checkExpired($data) {
  return get('/check/token', $data)
}
